import React from 'react';
import {Route} from 'react-router-dom';

import paths from '@paths';
import {Users} from '@pages';

const UsersRoutes: React.FC = () => {
  return (
    <>
      <Route exact path={paths.users.main} component={Users.Main} />
      <Route exact path={paths.users.create} component={Users.Create} />
      <Route path={paths.users.edit} component={Users.Edit} />
      <Route path={paths.users.detail} component={Users.Detail} />
    </>
  );
};

export default UsersRoutes;
